export { assets } from "@/config/assets";

const prodEnv = process.env.NODE_ENV === "production";
const production = window.location.host === "lexicon.games";
const context = prodEnv ? (production ? "production" : "staging") : "development";
export const version = "0.0.6";
console.log(`Lexicon Standoff - ${context} v${version}`);

const firebaseDevelopment = {
  apiKey: "AIzaSyAiUIRlN8uLm1zvlGdz4L5NPwJCSU0kUNs",
  authDomain: "lexiconstandoff.firebaseapp.com",
  databaseURL: "https://lexiconstandoff.firebaseio.com",
  projectId: "lexiconstandoff",
  storageBucket: "lexiconstandoff.appspot.com",
  messagingSenderId: "544721890687",
  appId: "1:544721890687:web:710fab7f4983c5e3fcbe4a",
  measurementId: "G-FVY2X1J8KT",
};

const firebaseProduction = firebaseDevelopment;

const shopifyDevelopment = {
  domain: "lexicon-standoff-dev.myshopify.com",
  storefrontAccessToken: "e08b3a434a3a95e53f0492d1d4e5d490",
};

const shopifyProduction = shopifyDevelopment;

export const firebase = production ? firebaseDevelopment : firebaseProduction;
export const shopify = production ? shopifyDevelopment : shopifyProduction;
